import {BrowserModule} from "@angular/platform-browser";
import {NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";

import {StartECasePreferencesComponent} from "./start-ecase-preferences.component";
import {StartECasePreferencesService} from "../start-ecase-preferences-service";
import {StartECaseService} from "../start-ecase-service";
import { LocalizationModule } from 'common-angular-module';
import { SortableModule } from 'ngx-bootstrap/sortable';

@NgModule({
  declarations: [
    StartECasePreferencesComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    LocalizationModule,
    SortableModule.forRoot()
  ],
  providers: [StartECasePreferencesService, StartECaseService],
  bootstrap: [StartECasePreferencesComponent]
})
export class StartECasePreferencesModule { }













// WEBPACK FOOTER //
// ./src/app/start-ecase-preferences/start-ecase-preferences.module.ts